module.exports = __webpack_public_path__ + "static/homepage-poster-8e010ef912c100b4433fb845c0ed675f.jpg";